import type { ActionFormationDTO } from '@/features/api/extranet/dto/Demande/AF'

export const preNotNirTemporaire = (_value: any, parent: any, _modele: ActionFormationDTO) =>
  parent?.nirTemporaire !== true
export const preNirTemporaire = (_value: any, parent: any, _modele: ActionFormationDTO) =>
  parent?.nirTemporaire === true
